import { gql } from '@apollo/client';

export const fetchTransactionAccountForEditBillingProfilePane = gql`
  query fetchTransactionAccountForEditBillingProfilePane($id: ID!) {
    transactionAccount(id: $id) {
      id
      availableShipToParties {
        totalCount
        nodes {
          name
          id
          name
          taxId
          taxIds {
            id
          }
          addressLine1
          addressLine2
          city
          country
          state
          postcode
        }
      }
      billToParty {
        id
        name
        taxId
        taxIds {
          id
        }
        addressLine1
        addressLine2
        city
        country
        state
        postcode
      }
    }
  }
`;
